// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"159":"component---src-templates-standard-tsx","218":"component---src-pages-404-tsx","351":"commons","532":"styles"}[chunkId] + "-" + {"159":"2af1774ee7fdc0196442","218":"a07a4e840d5ab7029574","351":"7429031c6df80cb40c22","532":"d8ac46f6d7cbe25110f2"}[chunkId] + ".js";
};